import { fetchHousingListSsr } from '@/features/pages/housing-list/api';
import { type Locale } from '@/config/i18n/locales';
import { OfferType } from '@/types';
import { Discounted } from './Discounted';
import { StructuredData } from '@/components/common/StructuredData/StructuredData';
import { generateDiscountedListingsSchema } from '@/common';
import { inheritSsrContext } from '@/lib/ssrRequestContext';

type DiscountedAsyncProps = {
  locale: Locale;
  pageId: string;
};

export const DiscountedAsync = async ({ locale, pageId }: DiscountedAsyncProps) =>
  inheritSsrContext(pageId, 'home:ssr', async () => {
    const data = await fetchHousingListSsr({ offerType: OfferType.RENT, itemsPerPage: 6 }, locale);
    const schemas = data?.objects?.length
      ? generateDiscountedListingsSchema(data.objects, locale)
      : null;
    return (
      <>
        {schemas?.length ? <StructuredData data={schemas} /> : null}
        <Discounted data={data?.objects} />
      </>
    );
  });
